<ion-content>
	<ion-list
		*ngIf="additionalCharges?.length > 0; else empty"
		lines="full"
		class="charges"
	>
		<ion-item *ngFor="let charge of additionalCharges">
			<ion-label>
				<div class="charge">
					<div class="charge__content">
						<h2 class="charge__title">
							{{ charge.desc }}
						</h2>
						<h3 class="charge__subtitle">
							Qty: {{ charge.qty }}, Billable:
							{{ charge.billable ? "Yes" : "No" }}
						</h3>
					</div>
					<div class="charge__actions">
						<ion-button
							fill="clear"
							slot="end"
							(click)="onClickDeleteCharge(charge)"
						>
							<ion-icon
								slot="icon-only"
								name="trash-outline"
								color="danger"
							></ion-icon>
						</ion-button>
					</div>
				</div>
			</ion-label>
		</ion-item>
	</ion-list>

	<ng-template #empty>
		<app-empty-list-item
			message="No additional charges exist"
		></app-empty-list-item>
	</ng-template>
</ion-content>

<ion-fab vertical="bottom" horizontal="end" slot="fixed">
	<ion-fab-button (click)="onClickGoToAddCharge()">
		<ion-icon name="add"></ion-icon>
	</ion-fab-button>
</ion-fab>
